<template>
  <div>
    <div class="d-flex w-100 justify-space-between">
      <h1 class="header-style">
        Daily Site Overview
      </h1>
    </div>
    <div class="d-flex refresh-btn flex-column align-end">
      <v-btn
        color="#ffffff"
        elevation="0"
        class="mb-1"
        @click="fetchDailyReports()"
      >
        <v-icon color="#37474F">
          mdi-refresh
        </v-icon>
      </v-btn>

      <span
        class="text-caption"
        style="color: #90a4ae"
      >
        Updated few minutes ago
      </span>
    </div>
    <br>
    <div class="pb-2">
      <v-card
        elevation="0"
        color="#FFF"
        class="card-style"
      >
        <div class="stats-container">
          <div class="stat-box checked-in">
            <p class="label pb-2">
              Checked-In
            </p>
            <p class="count">
              {{ dailyReports.total_workers_present || "0" }}
            </p>
          </div>

          <div class="stat-box not-in">
            <p class="label pb-2">
              Not In
            </p>
            <p class="count">
              {{ dailyReports.absentees || "0" }}
            </p>
          </div>

          <div class="stat-box active-projects">
            <p class="label">
              Active Projects
            </p>
            <p class="count">
              {{ dailyReports.projects || "0" }}
            </p>
          </div>
        </div>

        <div class="hours-container">
          <div class="hours-box">
            <span class="hours-title"> Total Hours </span>
            <p class="hours-total">
              {{ dailyReports.total_completed_hours || '00:00' }}
            </p>

            <div class="d-flex justify-space-between mt-3">
              <div class="text-left">
                <p class="sub-label mb-1">
                  Regular
                </p>
                <p class="regular-hours">
                  {{ dailyReports.regular_hours || '00:00' }}
                </p>
              </div>

              <div class="text-right">
                <p class="sub-label mb-1">
                  Overtime
                </p>
                <p class="overtime-hours">
                  {{ dailyReports.overtime_hours || '00:00' }}
                </p>
              </div>
            </div>
          </div>

          <div class="alerts-box">
            <div class="d-flex align-center mb-3">
              <v-icon
                size="18"
                color="#e74c3c"
                class="mr-1"
              >
                mdi-alert-outline
              </v-icon>
              <span class="alerts-title"> Alerts </span>
            </div>

            <span class="alerts-list">
              <li>Auto check-outs: {{ dailyReports.auto_checkouts || '0' }}</li>
              <li>
                Suspicious Checkins: {{ dailyReports.suspicious_checkins || '0' }}
              </li>
              <li>Overtime worker: {{ dailyReports.overtime_workers || '0' }}</li>
            </span>
          </div>
        </div>
      </v-card>
    </div>
    <v-card
      elevation="0"
      color="#FFF"
      class="card-style"
    >
      <h4 class="pb-2">
        Project-wise summary
      </h4>
      <div
        v-if="dailyReports['project-attendance']"
      >
        <v-row>
          <v-col cols="7" />
          <v-col cols="5">
            <v-row>
              <v-col
                cols="6"
                class="project-titles-hours"
              >
                <span class="list-title">Regular</span>
              </v-col>
              <v-col
                cols="6"
                class="project-titles"
              >
                <span class="list-title">Overtime</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div
          v-for="(item, projectName) in dailyReports['project-attendance']"
          :key="projectName"
        >
          <v-row>
            <v-col
              cols="7"
              class="names-col"
            >
              <div class="names-list d-flex justify-space-between items-center">
                <span class="project-name">{{ cutShort(projectName) }}</span>
                <span class="list-title">Workers : {{ item.total_workers }} </span>
              </div>
            </v-col>

            <v-col cols="5">
              <v-row>
                <v-col
                  cols="6"
                  class="list-col-left"
                >
                  <div class="time-list d-flex">
                    <span class="list-title">{{ item.regular_hours || '00:00' }}</span>
                  </div>
                </v-col>

                <v-col
                  cols="6"
                  class="list-col-right"
                >
                  <div class="time-list d-flex">
                    <span class="list-title">{{ item.overtime_hours || '00:00' }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </div>
      <div
        v-else
        class="empty-alert-div"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>No summary found
          </p>
          <br>
          <br>
        </v-card>
      </div>
    </v-card>
    <div>
      <v-card
        elevation="0"
        color="#FFF"
        class="card-style mt-2"
      >
        <h4 class="pb-2">
          Check-ins by Time Slot
        </h4>
        <div v-if="dailyReports['site-attendance']">
          <div
            v-for="(count, key) in dailyReports['site-attendance']"
            :key="key"
          >
            <v-row>
              <v-col
                cols="10"
                class="list-col-left"
              >
                <div
                  class="timing-list d-flex justify-space-between items-center"
                >
                  <span class="list-title">{{
                    key.split("to")[0].trim()
                  }}</span>
                  <span>-</span>
                  <span class="list-title">{{
                    key.split("to")[1].trim()
                  }}</span>
                </div>
              </v-col>

              <v-col
                cols="2"
                class="list-col-right"
              >
                <div class="timing-list d-flex justify-content-center">
                  <span class="list-title">{{ count }}</span>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div
          v-else
          class="empty-alert-div"
        >
          <v-card
            color="#FFF"
            elevation="0"
          >
            <br>
            <br>
            <br>
            <p class="empty-alert-msg">
              <v-icon
                size="25"
                color="#C62828"
              >
                mdi-information-outline
              </v-icon>No time-slot attendance found
            </p>
            <br>
            <br>
          </v-card>
        </div>
      </v-card>
    </div>
    <center-spinner :loading="loading" />
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';

export default {
  name: 'ReportsList',
  components: {
    'center-spinner': spinner,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    dailyReports () {
      return this.$store.getters['organization/getDailyReports'];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  mounted () {
   this.fetchDailyReports();
  },
  methods: {
    async fetchDailyReports () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchDailyReports', this.selectedOrganization)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    cutShort (val) {
      if (val.length > 13) {
        return val.substring(0, 11) + '...';
      }
      return val;
    },
  },
};
</script>
<style>
.card-style {
  padding: 8px 10px !important;
}
.stats-container,
.hours-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.hours-container {
  margin-top: 10px;
}
.stat-box {
  width: 100%;
  padding: 5px 2px;
  border-radius: 10px;
  text-align: center;
  background: #fafafa;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}
.stat-box .count {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0px !important;
}
.label {
  font-size: 10px;
  color: #666;
  margin-bottom: 0px !important;
}
.checked-in {
  background-color: #2ecc703d;
  border: 1px solid #2ecc708e;
}
.not-in {
  background-color: #e74d3c48;
  border: 1px solid #e74d3c8f;
}
.active-projects {
  background-color: #3498db3b;
  border: 1px solid #3498db8f;
}
.hours-box {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background-color: #f0f6ff;
}
.hours-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 0;
}
.hours-total {
  font-size: 22px;
  font-weight: 600;
}
.sub-label {
  font-size: 12px;
  color: #666;
}
.regular-hours {
  font-size: 16px;
  font-weight: 600;
  color: #27ae60;
}
.overtime-hours {
  font-size: 16px;
  font-weight: 600;
  color: #c0392b;
}
.alerts-box {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background-color: #e74d3c48;
}
.alerts-title {
  font-weight: 600;
  margin: 0;
}
.alerts-list {
  margin: 0;
  font-size: 13px;
  padding-left: 0px;
}
.alerts-list li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  color: #666;
}
.list-title {
  font-size: 13px;
  font-weight: normal;
}
.project-name {
  font-size: 13px;
  font-weight: bold;
}
.names-list {
  padding: 10px;
  border-radius: 10px;
  background: #27ae5f31;
}
.timing-list {
  padding: 10px;
  border-radius: 10px;
  background: #f0f6ff;
}
.time-list {
  padding: 10px;
  border-radius: 10px;
  background: #27ae5f31;
}
.names-col {
  padding-right: 0px !important;
}
.list-col-left {
  padding-right: 5px;
}
.list-col-right {
  padding-left: 5px;
}
.project-titles-hours {
  padding-right: 0px;
  display: flex;
}
.project-titles-hours .list-title,
.project-titles .list-title {
  font-size: 10px;
}
.project-titles {
  padding-left: 0px;
  display: flex;
}
</style>
